// LIST
export const FETCH_ALLERGY = "app/ALLERGY/FETCH_ALLERGY";
export const FETCH_ALLERGY_SUCCESS = "app/ALLERGY/FETCH_ALLERGY_SUCCESS";
export const FETCH_ALLERGY_FAILURE = "app/ALLERGY/FETCH_ALLERGY_FAILURE";

// ADD
export const ADD_ALLERGY = "app/ALLERGY/ADD_ALLERGY";
export const ADD_ALLERGY_SUCCESS = "app/ALLERGY/ADD_ALLERGY_SUCCESS";
export const ADD_ALLERGY_FAILURE = "app/ALLERGY/ADD_ALLERGY_FAILURE";

// EDIT
export const EDIT_ALLERGY = "app/ALLERGY/EDIT_ALLERGY";
export const EDIT_ALLERGY_SUCCESS = "app/ALLERGY/EDIT_ALLERGY_SUCCESS";
export const EDIT_ALLERGY_FAILURE = "app/ALLERGY/EDIT_ALLERGY_FAILURE";

// DELETE
export const DELETE_ALLERGY = "app/ALLERGY/DELETE_ALLERGY";
export const DELETE_ALLERGY_SUCCESS = "app/ALLERGY/DELETE_ALLERGY_SUCCESS";
export const DELETE_ALLERGY_FAILURE = "app/ALLERGY/DELETE_ALLERGY_FAILURE";

// MODAL
export const TOGGLE_ALLERGY_MODAL = "app/ALLERGY/TOGGLE_ALLERGY_MODAL";

// REGISTER (register-facade layer: rows + rag + assertions for a resident)
export const FETCH_ALLERGY_REGISTER = "app/ALLERGY/FETCH_ALLERGY_REGISTER";
export const FETCH_ALLERGY_REGISTER_SUCCESS =
  "app/ALLERGY/FETCH_ALLERGY_REGISTER_SUCCESS";
export const FETCH_ALLERGY_REGISTER_FAILURE =
  "app/ALLERGY/FETCH_ALLERGY_REGISTER_FAILURE";

// REGISTER DATA TOUCHED — a shared "a register changed" tick. Any register CRUD
// (allergies / vaccinations / baselines, via the Registers modal) bumps a
// version counter so surfaces that count register rows once per resident (the
// top-bar chips) refetch without a remount.
export const REGISTER_DATA_TOUCHED = "app/ALLERGY/REGISTER_DATA_TOUCHED";

// REGISTER ASSERTION (e.g. "no known allergies")
export const SET_REGISTER_ASSERTION = "app/ALLERGY/SET_REGISTER_ASSERTION";
export const SET_REGISTER_ASSERTION_SUCCESS =
  "app/ALLERGY/SET_REGISTER_ASSERTION_SUCCESS";
export const SET_REGISTER_ASSERTION_FAILURE =
  "app/ALLERGY/SET_REGISTER_ASSERTION_FAILURE";
